import React from 'react';
import { IntentSignal } from '../adapters/intentSignalAdapter';
import IntentProgressBar from './IntentProgressBar';

interface IntentSignalCardProps {
  signal: IntentSignal;
  hasFavorites: boolean;
}

const IntentSignalCard: React.FC<IntentSignalCardProps> = ({
  signal,
  hasFavorites,
}) => (
  <div
    className="p-2 mb-1"
    style={{
      background: '#fdf3e0',
      border: '1px solid #f0c674',
      borderRadius: 8,
      color: '#7a4d10',
    }}
  >
    <div className="font-weight-bold small">
      {signal.icon} {signal.title}
    </div>
    <div className="small">{signal.description}</div>
    <IntentProgressBar hasFavorites={hasFavorites} />
  </div>
);

export default IntentSignalCard;
